"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var mobx_1 = require("mobx");
var textColors = mobx_1.computed(function () { return [
    { name: owa_mail_strings_1.default.lightBlueColor, code: '#51a7f9' },
    { name: owa_mail_strings_1.default.lightGreenColor, code: '#6fc040' },
    { name: owa_mail_strings_1.default.lightYellowColor, code: '#f5d427' },
    { name: owa_mail_strings_1.default.lightOrangeColor, code: '#f3901d' },
    { name: owa_mail_strings_1.default.lightRedColor, code: '#ed5c57' },
    { name: owa_mail_strings_1.default.lightPurpleColor, code: '#b36ae2' },
    { name: owa_mail_strings_1.default.blueColor, code: '#0c64c0' },
    { name: owa_mail_strings_1.default.greenColor, code: '#0c882a' },
    { name: owa_mail_strings_1.default.yellowColor, code: '#dcbe22' },
    { name: owa_mail_strings_1.default.orangeColor, code: '#de6a19' },
    { name: owa_mail_strings_1.default.redColor, code: '#c82613' },
    { name: owa_mail_strings_1.default.purpleColor, code: '#763e9b' },
    { name: owa_mail_strings_1.default.darkBlueColor, code: '#174e86' },
    { name: owa_mail_strings_1.default.darkGreenColor, code: '#0f5c1a' },
    { name: owa_mail_strings_1.default.darkYellowColor, code: '#c3971d' },
    { name: owa_mail_strings_1.default.darkOrangeColor, code: '#be5b17' },
    { name: owa_mail_strings_1.default.darkRedColor, code: '#861106' },
    { name: owa_mail_strings_1.default.darkPurpleColor, code: '#5e327c' },
    { name: owa_mail_strings_1.default.darkerBlueColor, code: '#002451' },
    { name: owa_mail_strings_1.default.darkerGreenColor, code: '#06400c' },
    { name: owa_mail_strings_1.default.darkerYellowColor, code: '#a37519' },
    { name: owa_mail_strings_1.default.darkerOrangeColor, code: '#934511' },
    { name: owa_mail_strings_1.default.darkerRedColor, code: '#570606' },
    { name: owa_mail_strings_1.default.darkerPurpleColor, code: '#3b204d' },
    { name: owa_mail_strings_1.default.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: owa_mail_strings_1.default.lightGrayColor, code: '#cccccc' },
    { name: owa_mail_strings_1.default.grayColor, code: '#999999' },
    { name: owa_mail_strings_1.default.darkGrayColor, code: '#666666' },
    { name: owa_mail_strings_1.default.darkerGrayColor, code: '#333333' },
    { name: owa_mail_strings_1.default.blackColor, code: '#000000' },
]; });
exports.textColors = textColors;
var blackColors = mobx_1.computed(function () { return [
    { name: owa_mail_strings_1.default.cyanColor, code: '#00ffff' },
    { name: owa_mail_strings_1.default.greenColor, code: '#00ff00' },
    { name: owa_mail_strings_1.default.yellowColor, code: '#ffff00' },
    { name: owa_mail_strings_1.default.orangeColor, code: '#ff8000' },
    { name: owa_mail_strings_1.default.redColor, code: '#ff0000' },
    { name: owa_mail_strings_1.default.magentaColor, code: '#ff00ff' },
    { name: owa_mail_strings_1.default.lightCyanColor, code: '#80ffff' },
    { name: owa_mail_strings_1.default.lightGreenColor, code: '#80ff80' },
    { name: owa_mail_strings_1.default.lightYellowColor, code: '#ffff80' },
    { name: owa_mail_strings_1.default.lightOrangeColor, code: '#ffc080' },
    { name: owa_mail_strings_1.default.lightRedColor, code: '#ff8080' },
    { name: owa_mail_strings_1.default.lightMagentaColor, code: '#ff80ff' },
    { name: owa_mail_strings_1.default.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: owa_mail_strings_1.default.lightGrayColor, code: '#cccccc' },
    { name: owa_mail_strings_1.default.grayColor, code: '#999999' },
    { name: owa_mail_strings_1.default.darkGrayColor, code: '#666666' },
    { name: owa_mail_strings_1.default.darkerGrayColor, code: '#333333' },
    { name: owa_mail_strings_1.default.blackColor, code: '#000000' },
]; });
exports.blackColors = blackColors;
//# sourceMappingURL=Colors.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-color-picker/lib/utils/Colors.js
// module id = 3316
// module chunks = 2 59